import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ProgressiveImage from 'react-progressive-image';
import Title from 'components/mediabay-ui/components/Title';

const StyledLink = styled(Link)`
  position: relative;

  &:after {
    content: '${props => props.limit}';
    position: ${props => (props.limit ? 'absolute' : 'static')};
    top: 0;
    right: 0;
    width: 45px;
    height: 30px;
    background: #0773FF;
    text-align: center;
    line-height: 30px;
    font-weight: bold;
    border-radius: 0 0 0 10px;
  }
`;

class MediaItem extends React.Component {
  static propTypes = {
    // Data
    landscapeCover: PropTypes.bool,
    currentLanguage: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    route: PropTypes.string.isRequired,
    picture: PropTypes.string.isRequired,
    yearLimit: PropTypes.string,
    title: PropTypes.shape({
      eng: PropTypes.string,
      rus: PropTypes.string,
      uzb: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    landscapeCover: false,
    yearLimit: null,
  };

  render() {
    const {
      currentLanguage,
      id,
      route,
      picture,
      title,
      landscapeCover,
      yearLimit,
    } = this.props;

    return (
      <StyledLink
        to={route}
        key={id}
        data-id={id}
        limit={yearLimit}
        style={{ cursor: 'pointer', width: 200, margin: '20px 10px' }}
      >
        <ProgressiveImage
          delay={500}
          src={picture.replace(/.png|.jpg|.jpeg/, match => `.200${match}`)}
        >
          {(src, loading) => (
            loading ? (
              <div style={{ width: 200, height: landscapeCover ? 133 : 355, background: '#1e1e1e' }} />
            ) : (
              <img
                alt={title[currentLanguage] || title['ru']}
                src={src}
                width={200}
                height={landscapeCover ? 133 : 355}
                style={{ objectFit: 'cover' }}
              />
            )
          )}
        </ProgressiveImage>

        <Title>
          {title[currentLanguage] || title['ru']}
        </Title>
      </StyledLink>
    );
  }
}

export default MediaItem;
